import { render, staticRenderFns } from "./ProjectMapAsphaltSortCheckboxItem.vue?vue&type=template&id=172c70be"
import script from "./ProjectMapAsphaltSortCheckboxItem.vue?vue&type=script&lang=js"
export * from "./ProjectMapAsphaltSortCheckboxItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports